import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Day1_Card.css";

function Day1Card({
  item,
  icons,
  mainImage,
  changeMainImage,
  // index,
  // hideImages = false,
}) {
  const [activeMeal, setActiveMeal] = useState("breakfast");

  return (
    <div className="itinerary_card">
      <div className="day_card">
        {/* <div className="day_title">
          <h5>{item?.title}</h5>

          <i className="fa-solid fa-chevron-down day_toggle_icon"></i>
        </div> */}

        <div
          className="day_desc"
          dangerouslySetInnerHTML={{ __html: item?.description }}
        />

        {/* Transfer Section */}

        <div className="section_box">
          <div className="section_title">
            <img src={icons?.car} className="icon_img" alt="" />
            {item?.transferType}
          </div>

          <div className="transfer_mode">{item?.transferMode}</div>

          <div className="route_section">
            <div className="route_box">
              <p className="route_label">From</p>
              <div className="route_place">
                <img
                  src="/assets/images/cruise/itenarary/flight.png"
                  className="route_icon"
                  alt=""
                />
                {item?.ship_from}
              </div>
            </div>

            <div className="route_middle">
              <div className="route_line"></div>
            </div>

            <div className="route_box">
              <p className="route_label">To</p>
              <div className="route_place">
                <img
                  src="/assets/images/cruise/itenarary/hotel.png"
                  className="route_icon"
                  alt=""
                />
                {item?.to}
              </div>
            </div>
          </div>
        </div>

        {/* Stay Section */}
        <div className="section_box">
          <div className="section_title">
            <img src={icons?.bed} className="icon_img" alt="" />
            Stay at
          </div>
          <div className="hotel_name">
            Stay at {item?.hotel}
            <span className="hotel_rating">
              {/* <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i> */}
            </span>
          </div>
          <div className="check_row">
            <span>
              Check In <b>{item?.check_in}</b>
            </span>

            {/* <span>{item?.nights}</span> */}

            <span>
              Check Out <b>{item?.check_out}</b>
            </span>
          </div>
          {/* Main Image (Hidden in Summarised View) */}
          <img
            src={mainImage || item?.images?.[0]?.image}
            className="hotel_main_img"
            alt="hotel"
          />
          {/* Thumbnail Swiper (Hidden in Summarised View) */}

          <Swiper
            spaceBetween={10}
            breakpoints={{
              0: { slidesPerView: 4 },
              576: { slidesPerView: 6 },
              768: { slidesPerView: 5 },
              992: { slidesPerView: 6 },
              1024: { slidesPerView: 7 },
            }}
          >
            {item?.images?.map((img, i) => (
              <SwiperSlide key={i}>
                <img
                  key={i}
                  src={img?.image}
                  className="thumbImg"
                  onClick={() => changeMainImage(img?.image)}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          {!item && (
            <div className="inclusion_wrapper">
              <div className="inclusion_card">
                <div className="inclusion_left">
                  <h6>Standard</h6>
                  <p>Inclusions:</p>
                </div>

                <div className="inclusion_items">
                  <div
                    className={`inclusion_item ${
                      activeMeal === "breakfast" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("breakfast")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img1.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Breakfast</p>
                    <span className="inner_text">Included</span>
                  </div>

                  <div className="inclusion_divider"></div>

                  <div
                    className={`inclusion_item ${
                      activeMeal === "lunch" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("lunch")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img2.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Lunch</p>
                    <span className="inner_text">Not Included</span>
                  </div>

                  <div className="inclusion_divider"></div>

                  <div
                    className={`inclusion_item ${
                      activeMeal === "dinner" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("dinner")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img3.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Dinner</p>
                    <span className="inner_text">Not Included</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Day1Card;
